module.exports = __webpack_public_path__ + "static/media/ZIL-BNB.849576e4.svg";